// Recovered compiled webpack factory 20063. Edit this function expression; run npm run build.
(e, t, a) => {
  "use strict";
  var r = a(47260);
  (a.o(r, "useParams") &&
    a.d(t, {
      useParams: function () {
        return r.useParams;
      },
    }),
    a.o(r, "usePathname") &&
      a.d(t, {
        usePathname: function () {
          return r.usePathname;
        },
      }),
    a.o(r, "useRouter") &&
      a.d(t, {
        useRouter: function () {
          return r.useRouter;
        },
      }),
    a.o(r, "useSearchParams") &&
      a.d(t, {
        useSearchParams: function () {
          return r.useSearchParams;
        },
      }));
}
